import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { standardDrawing, setPositions } from '@moleculeone/draw';

import { calculateSeededPositions } from '@f/utils/mol';
import { smilesToMol, molToSmiles } from '@f/utils/conversion';

import DrawnMolecule from './DrawnMolecule';
import Toolbox from './toolbox/Toolbox';

export { BOND_CUT_APPLIED, BOND_CUT_DESIRED } from './DrawnMolecule';

export default class extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    smiles: PropTypes.string,
    mol: PropTypes.object,
    toolbox: PropTypes.bool,
    border: PropTypes.number,
    before: PropTypes.node,
    after: PropTypes.node,
    cutData: PropTypes.object,
    onClick: PropTypes.func,
    onMouseDown: PropTypes.func,
    onMouseUp: PropTypes.func,
    onMouseMove: PropTypes.func,
    onDidRedraw: PropTypes.func,
  };

  static defaultProps = {
    toolbox: true,
    onDidRedraw: () => {},
  };

  state = {
    smiles: null,
    mol: null,
  };

  async componentDidMount() {
    const { smiles, mol } = this.props;

    if (smiles && mol) {
      this.setState({
        smiles,
        mol,
      });
    } else if (smiles && !mol) {
      this.setState({
        smiles,
        mol: await smilesToMol(smiles),
      });
    } else if (!smiles && mol) {
      this.setState({
        smiles: await molToSmiles(mol),
        mol,
      });
    }
  }

  recalculateMol = () => {
    const { smiles, mol } = this.state;

    if (!mol) {
      return;
    }

    const nextMol = setPositions(
      mol,
      calculateSeededPositions({
        mol,
        seedId: smiles,
        incrementSeed: true,
      })
    );

    this.setState({
      mol: nextMol,
    });
  };

  onRedraw = () => {
    this.recalculateMol();
    this.props.onDidRedraw();
  };

  render() {
    const { className, toolbox, border, before, after, cutData, onClick, onMouseDown, onMouseUp, onMouseMove } =
      this.props;
    const { smiles, mol } = this.state;

    if (!mol || (toolbox && !smiles)) {
      return null;
    }

    const drawnMol = standardDrawing(mol);

    return (
      <DrawnMolecule
        className={className}
        drawnMol={drawnMol}
        size={drawnMol.bbox.size}
        toolbox={toolbox && <Toolbox smiles={smiles} mol={drawnMol} onRedraw={this.onRedraw} />}
        border={border}
        before={before}
        after={after}
        cutData={cutData}
        onClick={onClick}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onMouseMove={onMouseMove}
      />
    );
  }
}
